import { ChargeWaiverEntity } from "domain/entity/ChargeWaiver/ChargeWaiverEntity";
import { ChargeWaiverConstant } from "presentation/constant/ChargeWaiver/ChargeWaiverConstant";
import { useChargeWaiverVM } from "presentation/hook/ChargeWaiver/useChargeWaiverVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useChargeWaiverTracked } from "presentation/store/ChargeWaiver/ChargeWaiverProvider";
import { memo, useState } from "react";
import { HPHButton, IconButton, Loader } from "veronica-ui-component/dist/component/core";
import { SidebarActionBar, SidebarActionCross, SidebarTitle, Sidebarheader } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";
import { ChargeWaiverEditForm } from "./ChargeWaiverEditForm";


const ChargeWaiverEditPanel = () => {
    const [chargeWaiverState] = useChargeWaiverTracked();
    const chargeWaiverVM = useChargeWaiverVM();
    const messageBarVM = useMessageBarVM();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const { editData, searchCriteria, isShowBulkEditPanel, selectedRows } = chargeWaiverState;

    const saveButtonClicked = async () => {
        setIsLoading(true);
        let editDatas: ChargeWaiverEntity[] = [];
        if (isShowBulkEditPanel) {
            editDatas = selectedRows.map(item => ({
                ...item,
                waiverNoOfDays: editData.waiverNoOfDays,
                batNo: editData.batNo,
                remark1: editData.remark1,
                reasonForRecommendation: editData.reasonForRecommendation,
                waiverPercentage: editData.waiverPercentage,
            }));
        } else {
            editDatas.push(editData);
        }
        chargeWaiverVM.onSaveClicked();
        await chargeWaiverVM.onEditSaveClick(editDatas, isShowBulkEditPanel).then(async (res) => {
            if (res && res.success) {
                if (isShowBulkEditPanel && res.data) {
                    setIsLoading(false);
                    messageBarVM.showError(res.data);
                    return;
                }
                messageBarVM.showSuccess("Update Successfully");
                chargeWaiverVM.onEditCloseClick();
                await chargeWaiverVM.searchChargeWaiverData(searchCriteria).then((data) => {
                    setIsLoading(false);
                });
            } else {
                if (res.msg && res.msg === 'ERROR' && Object.keys(res.data).length > 0) {
                    setIsLoading(false);
                    //messageBarVM.showError(res.data);
                    return;
                } else {
                    if (!!!res?.data) {
                        messageBarVM.showError("Update Failed.");
                        chargeWaiverVM.onEditCloseClick();
                        await chargeWaiverVM.searchChargeWaiverData(searchCriteria).then((data) => {
                            setIsLoading(false);
                        });
                    }
                }
                // if (!!!res?.data) {
                //     messageBarVM.showError("Update Failed.");
                //     chargeWaiverVM.onEditCloseClick();
                //     await chargeWaiverVM.searchChargeWaiverData(searchCriteria).then((data) => {
                //         setIsLoading(false);
                //     });
                // } else {
                //     messageBarVM.showError(res?.data as string);
                // }
            }
            setIsLoading(false);
        }).catch(() => {
            setIsLoading(false);
        })
    }

    const closeButtonClicked = async () => {
        chargeWaiverVM.onEditCloseClick();
    }

    /*const memoTitle = useMemo(() => {
        if (isShowBulkEditPanel) {
            return <>{ChargeWaiverConstant.Title.UPDATE}</>
        } else if (isShowEditPanel) {
            let title = '';
            if (isShowDelayDelivery) {
                title = 'Delay Delivery';
            } else if (isShowDelayGrding) {
                title = 'Delay Grounding';
            } else if (isShowGenWaiverByCom) {
                title = 'General Waiver by Commercial';
            } else if (isShowRolloverChg) {
                title = 'Rollover Charges';
            } else if (isShowStackHold) {
                title = 'Stuck/Missing/Stack Hold';
            }
            return <>{title}</>
        }
    }, [isShowEditPanel, isShowBulkEditPanel, isShowDelayDelivery, isShowDelayGrding, isShowGenWaiverByCom, isShowRolloverChg, isShowStackHold]);*/

    return (
        <div className='side-form-content-wrapper'>
            <div className={'flex-row'}>
                <div className={'flex-row-item flex-row-item-full-width'}>
                    <Sidebarheader>
                        <SidebarTitle>
                            {ChargeWaiverConstant.Title.UPDATE}
                        </SidebarTitle>
                        <SidebarActionCross>
                            <IconButton
                                fileName="Icon-cross" size="medium" toolTipText='Close' toolTipArrow={false} onClick={closeButtonClicked} />
                        </SidebarActionCross>
                    </Sidebarheader>
                </div>
            </div>
            {isLoading &&
                <Loader Indicator="Spinner" size="Medium" />}
            {<>
                <div className={'add-edit-form'} style={{ height: '75vh', maxHeight: '75vh', overflow: 'auto' }}>
                    <div className="flex-row-auto">
                        <div className={'flex-row-item'}>
                            <ChargeWaiverEditForm />
                        </div>
                    </div>
                </div>
                <SidebarActionBar>
                    {/* <HPHButton label={'Close'} size={'Small'} theme={'Secondary'} onClick={closeButtonClicked} /> */}
                    <HPHButton label={'Save'} size={'Small'} theme={'Primary'} onClick={saveButtonClicked} />
                </SidebarActionBar>
            </>}
        </div>
    );
}

export default memo(ChargeWaiverEditPanel);